import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';
export function FinalCta() {
  return <section className="bg-charcoal py-16 text-white sm:py-20" data-id="element-111" data-mp="vg7qnzl5q2i9">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-112" data-mp="19epbnpjoh0wh">
        <h2 className="mx-auto max-w-[18ch] font-display text-[1.85rem] font-extrabold leading-[1.1] tracking-tight sm:max-w-[26ch] sm:text-[2.8rem]" data-id="element-113" data-mp="19ga6zhdtgnve">
          Tu primera venta no empieza con 500 recetas.
          <span className="mt-2 block text-coral" data-id="element-114" data-mp="1jb23ehvnx4ol">Empieza eligiendo las correctas.</span>
        </h2>

        <p className="mx-auto mt-5 max-w-[46ch] font-sans text-[0.93rem] leading-relaxed text-white/70 sm:text-[1rem]" data-id="element-115" data-mp="1ebxtfp0wz2x7">
          Postres que Venden™ reúne el sistema, las recetas y las herramientas para ayudarte a
          transformar una cocina hogareña en un punto de partida.
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-116" data-mp="221jsmchadi57">
          <div className="flex items-center gap-2.5" data-id="element-117" data-mp="1x5ky075d73wc">
            <p className="font-sans text-sm font-medium tabular-nums text-white/50 sm:text-base" style={{
            textDecoration: 'line-through'
          }} data-id="element-118" data-mp="1x2p0gjxfih8f">
              {PRICE.previous}
            </p>
            <span className="rounded-full bg-gold px-2.5 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-white" data-id="element-119" data-mp="x38z7sld3w4u">
              Oferta
            </span>
          </div>
          <p className="mt-1 font-display text-[3rem] font-extrabold leading-[0.95] tracking-tight tabular-nums text-white sm:text-[3.8rem]" data-id="element-120" data-mp="1650630rn290a">
            {PRICE.current}
          </p>
          <p className="mt-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-white/60" data-id="element-121" data-mp="1fua04m61m1r1">
            {PRICE.note}
          </p>
        </div>

        <div className="mt-7 flex justify-center" data-id="element-122" data-mp="1ksl4wihhdm2e">
          <CTAButton className="w-full max-w-[26rem] px-4" label="QUIERO EMPEZAR AHORA" data-id="element-123" data-mp="1pszei4yqd42j" />
        </div>

        <p className="mt-3.5 font-sans text-[0.76rem] font-medium text-white/70" data-id="element-124" data-mp="1tt9m1m2682ji">
          Acceso inmediato · 100% digital · Aplicalo desde tu propia cocina
        </p>
      </div>
    </section>;
}